import React, { useState, useEffect, useRef } from 'react';
import { Select, Row, Col } from 'antd';
import { loadStreams, loadClassStreamCategories, bringsStreamsAndCategoriesInClassAndDivision } from "../../services/ide-apis";
import { global_var } from "../../services/cs-lab-config";

const { Option } = Select;

const StreamLoader = ({onChange, classDivision}) => {
    document.title = 'Stream Loader';
    const [streamCategory, setStreamCategory] = useState([]);
    const [streams, setStreams] = useState([]);
    const [originalStreamCategory, setOriginalStreamCategory] = useState([]);
    const [streamLoading, setStreamLoading] = useState(false);
    const [streamCategoryLoading, setStreamCategoryLoading] = useState(false);

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedStream, setSelectedStream] = useState(null);
    const previousClassDivisionRef = useRef(null);

    useEffect(() => {
        setStreamCategoryLoading(true)
        loadClassStreamCategories({}).then((response) => {
            let data = response.data;
            if (data.statusCode === 200){
                data = data.streams;
            }

            setStreamCategory(data)
            setOriginalStreamCategory(data);
            setStreamCategoryLoading(false)
        })
    },[]);

    useEffect(() => {
        setStreamCategoryLoading(true)
        let requestObj = {}
        if (classDivision && classDivision.fkClassId && classDivision.fkDivisionId ) {
            if(previousClassDivisionRef.current){
                if(previousClassDivisionRef.current.fkClassId === classDivision.fkClassId || previousClassDivisionRef.current.fkDivisionId !== classDivision.fkDivisionId){
                    return;
                }
            }
            requestObj.classId = classDivision.fkClassId
            requestObj.divisionId = classDivision.fkDivisionId
            requestObj.academicYearId = global_var.academicYearId
            bringsStreamsAndCategoriesInClassAndDivision(requestObj).then((response) => {
                let data = JSON.parse(response.data)
                let filteredStreamCategory = originalStreamCategory.filter(category => {
                    return data.streamCategories.includes(category._id['$oid']);
                });
                if(!filteredStreamCategory.length){
                    setSelectedCategory(null);
                    setSelectedStream(null);
                    setStreams([])
                    onChange({classStreamName: '', streamId: ''})}
                setStreamCategory(filteredStreamCategory)
            })
            previousClassDivisionRef.current = classDivision;
        }
        setStreamCategoryLoading(false)

    }, [classDivision, originalStreamCategory, onChange]);

    const handleStreamCategory = (value, option ) =>{
        setSelectedCategory(value);
        setStreamLoading(true)
        let requestObj = {
            companyId : global_var.company_id,
            streamCategoryId : option.data._id["$oid"]
        }
        loadStreams(requestObj).then((response) => {
            let data = response.data;
            if (data.statusCode === 200){
                data = data.streams;
            }
            
            setStreams(data)
            setStreamLoading(false)
        })
    }

    const handleStreamSelect = (value, option) => {
        setSelectedStream(value);
        if (onChange && option) {
            const convertedId = option.data._id ? option.data._id.$oid : option.data.fkGroupId;
            const dataToSend = {
              classStreamName: option.data.classStreamName,
              streamId: convertedId
            };
            onChange(dataToSend);
        }
    };

    return (
        <Row className="mb-2">
            <Col span={10} style={{ marginRight: "8px" }}>
                <Select
                    placeholder="Select category"
                    style={{ width: '100%' }}
                    onChange={handleStreamCategory}  
                    optionLabelProp="label"
                    showSearch
                    loading={streamCategoryLoading}
                    value={selectedCategory}
                >
                    {streamCategory.map((category) => (
                        <Option key={category.classStreamCategoryName} data={category} value={category.classStreamCategoryName} label={category.classStreamCategoryName}>
                            {category.classStreamCategoryName}
                        </Option>
                    ))}
                </Select>
            </Col>
            <Col span={10}>
                <Select
                    placeholder="Main Stream"
                    style={{ width: '100%' }}
                    onChange={handleStreamSelect}  
                    optionLabelProp="label"
                    showSearch
                    loading={streamLoading}
                    value={selectedStream}
                >
                    {streams.map((stream) => (
                        <Option key={stream.classStreamName} data={stream} value={stream.classStreamName} label={stream.classStreamName}>
                            {stream.classStreamName}
                        </Option>
                    ))}
                </Select>
            </Col>
        </Row>
    );
};

export default StreamLoader;
